import { render, staticRenderFns } from "./departPage.vue?vue&type=template&id=75120e2c&scoped=true"
import script from "./departPage.vue?vue&type=script&lang=js"
export * from "./departPage.vue?vue&type=script&lang=js"
import style0 from "./departPage.vue?vue&type=style&index=0&id=75120e2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75120e2c",
  null
  
)

export default component.exports